<!-- src/app/pages/cost-metrics/net-benefits/net-benefits.html -->
@if (!showHint) {
<div class="costAnalysis">
    <div class="grid grid-cols-12 gap-4">
        <!-- Health Sector Cost -->
        <div class="col-span-12 lg:col-span-4 chartWrap">
            <div class="rounded-2xl p-4 md:p-6">
                <div class="flex items-center justify-between">
                    <h2 class="font-semibold text-lg">Health Sector Cost ($)</h2>
                </div>
                <div class="dashboardHide scenerioTable">
                    <div class="space-y-3 text-sm">
                        <table class="table-auto">
                            <thead>
                                <tr>
                                    <th>Scenerio Comparison</th>
                                    <th>Base</th>
                                    <th>Current</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Intervention</td>
                                    <td><b>{{ healthSector.intervention.base }}</b></td>
                                    <td><b>{{ healthSector.intervention.current }}</b></td>
                                </tr>
                                <tr>
                                    <td>Health System</td>
                                    <td><b>{{ healthSector.healthSystem.base }}</b></td>
                                    <td><b>{{ healthSector.healthSystem.current }}</b></td>
                                </tr>
                                <br />
                                <tr>
                                    <td>Total</td>
                                    <td><b>{{ healthSector.total.base }}</b></td>
                                    <td><b>{{ healthSector.total.current }}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="my-4 border-t border-slate-200"></div>
                </div>
            </div>
        </div>
        <!-- Quality Adjusted Life Years -->
        <div class="col-span-12 lg:col-span-4 chartWrap">
            <div class="rounded-2xl p-4 md:p-6">
                <div class="flex items-center justify-between">
                    <h2 class="font-semibold text-lg">Quality Adjusted Life Years ($)</h2>
                </div>
                <div class="dashboardHide scenerioTable">
                    <div class="space-y-3 text-sm">
                        <table class="table-auto">
                            <thead>
                                <tr>
                                    <th>Scenerio Comparison</th>
                                    <th>Base</th>
                                    <th>Current</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>QALY's</td>
                                    <td><b>{{ qaly.qalys.base }}</b></td>
                                    <td><b>{{ qaly.qalys.current }}</b></td>
                                </tr>
                                <tr>
                                    <td>$ per QALY gained</td>
                                    <td colspan="2"><b>{{ qaly.valuePerQaly }}</b></td>
                                </tr>
                                <br />
                                <tr>
                                    <td>Monetised QALY gained</td>
                                    <td><b>{{ qaly.monetised.base }}</b></td>
                                    <td><b>{{ qaly.monetised.current }}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="my-4 border-t border-slate-200"></div>
                </div>
            </div>
        </div>
        <!-- Broader societal cost -->
        <div class="col-span-12 lg:col-span-4 chartWrap">
            <div class="rounded-2xl p-4 md:p-6">
                <div class="flex items-center justify-between">
                    <h2 class="font-semibold text-lg">Broader societal cost ($)</h2>
                </div>
                <div class="dashboardHide scenerioTable">
                    <div class="space-y-3 text-sm">
                        <table class="table-auto">
                            <thead>
                                <tr>
                                    <th>Scenerio Comparison</th>
                                    <th>Base</th>
                                    <th>Current</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Societal</td>
                                    <td><b>{{ societal.societal.base }}</b></td>
                                    <td><b>{{ societal.societal.current }}</b></td>
                                </tr>
                                <tr>
                                    <td>Health Sector</td>
                                    <td><b>{{ societal.healthSector.base }}</b></td>
                                    <td><b>{{ societal.healthSector.current }}</b></td>
                                </tr>
                                <br />
                                <tr>
                                    <td>Total</td>
                                    <td><b>{{ societal.total.base }}</b></td>
                                    <td><b>{{ societal.total.current }}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="my-4 border-t border-slate-200"></div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Scenario Comparison -->
<div class="netScenerio">
    <div class="tableWrap">
        <div class="headingBlk flex items-center justify-between">
            <h3>Scenerio Comparison</h3>
            <!-- Toggle: OFF by default → Health Sector Cost -->
            <div class="flex items-center gap-2">
                <span class="text-sm text-white"> {{ isBroaderSocietal ? 'View Health Sector Cost' : 'View Broader Societal cost' }} </span>
                <p-toggleSwitch [(ngModel)]="isBroaderSocietal" (onChange)="onToggle()"></p-toggleSwitch>
            </div>
        </div>
        <table class="table table-auto">
            <thead>
                <tr>
                    <th>Scenerio Comparison</th>
                    <th>Base</th>
                    <th>Current</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Monetised QALY</td>
                    <td>{{ scenario.monetisedQaly.base }}</td>
                    <td>{{ scenario.monetisedQaly.current }}</td>
                </tr>
                <tr>
                    <td>{{ scenario.selectedCostLabel }}</td>
                    <td class="negSign"><span>( - )</span> {{ scenario.selectedCost.base }}</td>
                    <td class="negSign"><span>( - )</span> {{ scenario.selectedCost.current }}</td>
                </tr>
                <tr>
                    <td>Total</td>
                    <td>{{ scenario.total.base }}</td>
                    <td>{{ scenario.total.current }}</td>
                </tr>
                <br />
                <tr class="netValueWrap">
                    <td>Net Benefit:</td>
                    <td colspan="2" class="netValueTotal">{{ scenario.netBenefit }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
} @else {
<div class="rounded-lg border border-sky-200 bg-sky-50 text-sky-800 px-4 py-2 text-sm">Please add new simulation to view net benefits</div>
}
